/**
 * CustomerERP — merkezi marka bilgisi (Faz 0).
 * Kaynak: GET /api/app-profile/public  (Sistem Ayarları > Firma Bilgileri).
 * Kodda sabit firma adı/logosu YOK; firma adı boşsa "CustomerERP" görünür.
 */
import React, { createContext, useCallback, useContext, useEffect, useState } from "react";
import axios from "axios";
import { Building2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const DEFAULT_BRAND = "CustomerERP";

const initial = {
  brandName: DEFAULT_BRAND,
  companyName: "",
  logoUrl: "",
  features: { erp_assistant: false, whatsapp: false },
  loaded: false,
};

const BrandingContext = createContext({ ...initial, refresh: () => {} });

export function BrandingProvider({ children }) {
  const [state, setState] = useState(initial);
  const refresh = useCallback(async () => {
    try {
      const { data } = await axios.get(`${API}/app-profile/public`);
      setState({
        brandName: data.brand_name || DEFAULT_BRAND,
        companyName: data.company_name || "",
        logoUrl: data.logo_data_url || "",
        features: data.features || initial.features,
        loaded: true,
      });
    } catch {
      setState((s) => ({ ...s, loaded: true }));
    }
  }, []);
  useEffect(() => { refresh(); }, [refresh]);
  useEffect(() => {
    document.title = state.brandName || DEFAULT_BRAND;
  }, [state.brandName]);
  return (
    <BrandingContext.Provider value={{ ...state, refresh }}>
      {children}
    </BrandingContext.Provider>
  );
}

export function useBranding() {
  return useContext(BrandingContext);
}

/** "Bizim firma" seçenekleri — tek kaynak Firma Bilgileri (grup şirketi listesi yok). */
export function OwnCompanyOptions() {
  const { brandName } = useBranding();
  return <option value="">{brandName}</option>;
}

/** Logo varsa logo, yoksa generic simge. */
export function BrandMark({ className = "h-10 w-10", testId = "brand-mark" }) {
  const { logoUrl, brandName } = useBranding();
  if (logoUrl) {
    return <img src={logoUrl} alt={brandName} data-testid={testId} className={`${className} object-contain shrink-0`} />;
  }
  return (
    <div data-testid={testId}
      className={`${className} shrink-0 rounded-xl bg-gradient-to-br from-indigo-500 to-violet-600 text-white flex items-center justify-center shadow-sm`}>
      <Building2 size={20} strokeWidth={2} />
    </div>
  );
}
